import Big from 'Common/utils/customBig';

const adaptOmContractResponseData = data => ({
	...data,
	insurance: data.insurance ? Number(Big(data.insurance).times(100).toString()) : data.insurance,
});

export default adaptOmContractResponseData;
